import React, { useRef } from 'react';
import ModalDialog from '../../../core/components/Modal';
import InventoryTypeForm from '../components/InventoryTypeForm';
import { connect, useDispatch } from 'react-redux';
import { addInventoryType } from '../actions';

const AddInventoryTypeDialog = (props) => {
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const onReady = () => {
    if (formRef.current && formRef.current.submit) {
      formRef.current.submit();
    }
  };

  const onSubmit = (values) => {
    const types = values?.types || [];
    if (types.length > 0) {
      dispatch(addInventoryType(types));
    }
    if (props.callback) {
      props.callback();
    }
    if (props.hideDialog) {
      props.hideDialog();
    }
  };
  const submitDisabled = false;

  return (
    <ModalDialog
      title="Add Inventory Type"
      onReady={onReady}
      isOpen={props.isOpen}
      close={props.hideDialog}
      disabled={submitDisabled}
      className="enhanced-dialog narrow padded-minimal"
    >
      <InventoryTypeForm ref={formRef} onSubmit={onSubmit} {...props} />
    </ModalDialog>
  );
};

export default connect()(AddInventoryTypeDialog);
